import isEqualBounds from '../../common/helpers/is-equal-bounds';

const getItemsMatchingElementBounds = (elementBounds, items) =>
  items.filter((item) => isEqualBounds(elementBounds, item.element.getBoundingClientRect(), true));

export default getItemsMatchingElementBounds;
